const MatBiMIcon = () => {
    return (
        <svg
            role="graphics-document"
            xmlns="http://www.w3.org/2000/svg"
            // default width: 755.31
            // default height: 151
            height="37.5"

            viewBox="0 0 755.31 151"
            preserveAspectRatio="xMinYMid meet"
        >
            <defs>
                    {/* .a{fill:#f9b215;}.b{fill:#00528c;}.c{fill:none;}.d{fill:#ffb600;}</style> */}
            </defs>
            <circle className="fill-[#f9b215]" cx="606.75" cy="13.45" r="13.45"></circle>
            <path
                className="fill-[#00528c]"
                d="M194.32,0h20.4l35.4,80.8L285.72,0h20.4V150h-21.2V60.2L259.72,112h-18.8l-25.4-51.8V150h-21.2Z"
            ></path>
            <path
                className="fill-[#00528c]"
                d="M326.91,118.2V85.8c0-22.4,14-32.8,33-32.8,14.2,0,21.8,7,22.6,8.6V54h18v96h-18v-7.6c-1.2,1.8-8.8,8.6-22.6,8.6C340.91,151,326.91,140.6,326.91,118.2Zm53.6-5.2V91c0-9.8-2.8-18.4-17-18.4-12,0-16.6,8.6-16.6,18.4v22c0,9.8,4.6,18.4,16.6,18.4C377.71,131.4,380.51,122.8,380.51,113Z"
            ></path>
            <path
                className="fill-[#00528c]"
                d="M428.71,54V30.4h20V54h20.8V72h-20.8v39.8c0,12.6,5.8,18.6,17,18.6h3.8V150h-3.8c-23.2,0-37-12.4-37-32.8V72h-16V54Z"
            ></path>
            <path
                className="fill-[#00528c]"
                d="M489.51,0h36.2c24.2,0,41.6,14.4,41.6,33.8V51c0,8.8-4.2,15.4-11.4,20.8,12,6,16.6,16,16.6,25.6v18.8c0,19.4-17.4,33.8-41.6,33.8h-41.4Zm36.2,64.2c13.2,0,20.4-9,20.4-18.6v-7c0-11.6-8.4-18.6-20.4-18.6h-15.2V64.2Zm5.2,65.2c12,0,20.4-7,20.4-18.6v-8c0-11.6-8.4-18.6-20.4-18.6h-20.4v45.2Z"
            ></path>
            <path className="fill-[#00528c]" d="M596.51,54h20v96h-20Z"></path>
            <path
                className="fill-[#00528c]"
                d="M643.51,0h20.4l35.4,80.8L734.91,0h20.4V150h-21.2V60.2L708.91,112h-18.8l-25.4-51.8V150h-21.2Z"
            ></path>
            <path
                className="fill-none"
                d="M74.55,85.35q1.45,3.86,2.7,8L99.49,36.44C98.4,34.05,97.33,32,96.27,30.1L75,84.64A2.17,2.17,0,0,1,74.55,85.35Z"
            ></path>
            <path className="fill-none" d="M84,18.32c-4,.05-13,6.58-21.1,32.19L59.48,61a47.5,47.5,0,0,1,5.39,6.12Z"></path>
            <path
                className="fill-none"
                d="M82.65,121.84c.46,4.61.76,9.33.89,14.12l26.12-66.82q-1.11-5.13-2.38-10l-24.22,62A2.34,2.34,0,0,1,82.65,121.84Z"
            ></path>
            <path
                className="fill-none"
                d="M79.15,100.63c.85,3.6,1.58,7.34,2.19,11.18L105,51.26a1.66,1.66,0,0,0-.11-.38c-.88-2.79-1.77-5.35-2.66-7.71l-22,56.2A2.44,2.44,0,0,1,79.15,100.63Z"
            ></path>
            <path
                className="fill-none"
                d="M67.76,71.34a74.49,74.49,0,0,1,4.08,7.57L92.92,25a25.73,25.73,0,0,0-4.39-4.64L69.13,70A2.45,2.45,0,0,1,67.76,71.34Z"
            ></path>
            <path
                className="fill-[#f9b215]"
                d="M67.76,71.34A2.45,2.45,0,0,0,69.13,70l19.4-49.62a7.87,7.87,0,0,0-4.54-2h0L64.91,67.14Q66.36,69.11,67.76,71.34Z"
            ></path>
            <path
                className="fill-[#f9b215]"
                d="M73.9,83.64c.22.56.44,1.14.65,1.71a2.29,2.29,0,0,0,.4-.67L96.23,30.14A50,50,0,0,0,92.88,25l-21,53.92C72.55,80.44,73.23,82,73.9,83.64Z"
            ></path>
            <path
                className="fill-[#f9b215]"
                d="M79.15,100.63a2.48,2.48,0,0,0,1.13-1.26l22-56.2q-1.36-3.66-2.75-6.69L77.23,93.39C77.94,95.73,78.57,98.15,79.15,100.63Z"
            ></path>
            <path
                className="fill-[#f9b215]"
                d="M82.65,121.84a2.68,2.68,0,0,0,.41-.69l24.22-62c-.72-2.73-1.47-5.38-2.27-7.93L81.34,111.77C81.86,115.08,82.3,118.43,82.65,121.84Z"
            ></path>
            <path
                className="fill-[#f9b215]"
                d="M83.54,136c0,1.84.08,3.69.08,5.54a16.57,16.57,0,0,1-.11,1.86,2.4,2.4,0,0,0,.75.12,2.5,2.5,0,0,0,2.33-1.59l24.86-63.6c-.56-3.12-1.15-6.17-1.79-9.15Z"
            ></path>
            <path
                className="fill-[#f9b215]"
                d="M91,146.9a2.51,2.51,0,0,0,1.42,3.24,2.38,2.38,0,0,0,.91.18,2.5,2.5,0,0,0,2.33-1.6l18.87-48.27c-.37-3.56-.8-7-1.27-10.48Z"
            ></path>
            <path
                className="fill-[#f9b215]"
                d="M102.51,146.76A2.49,2.49,0,0,0,103.9,150h0a2.58,2.58,0,0,0,.91.17,2.5,2.5,0,0,0,2.33-1.59l9.19-23.49q-.25-6.09-.67-12Z"
            ></path>
            <path
                className="fill-[#ffb600]"
                d="M38.31,59.05c-15.87,0-25,17-29.08,27.18C3.23,101.14,0,120.77,0,141.5a9,9,0,0,0,18,0c0-40,13.15-64.45,20.31-64.45s20.31,24.47,20.31,64.45a9,9,0,1,0,18,0c0-20.73-3.27-40.36-9.22-55.27C63.35,76.08,54.23,59.05,38.31,59.05Z"
            ></path>
            <path
                className="fill-[#f9b215]"
                d="M84,.32C73.1.32,57.65,8.16,45.92,45.48c0,0-1.49,4.64-2.16,7.1A31.77,31.77,0,0,1,59.48,61l3.37-10.49C70.85,24.9,80,18.37,84,18.32h0a7.87,7.87,0,0,1,4.54,2A25.73,25.73,0,0,1,92.88,25a50,50,0,0,1,3.35,5.16c1.06,1.85,2.13,3.95,3.22,6.34q1.38,3,2.75,6.69c.89,2.36,1.78,4.92,2.66,7.71a1.47,1.47,0,0,0,.11.38c.8,2.55,1.55,5.2,2.27,7.93q1.28,4.81,2.38,10c.64,3,1.23,6,1.79,9.15q1,5.69,1.84,11.66c.47,3.43.9,6.92,1.27,10.48q.66,6.2,1.12,12.64.42,5.93.67,12c.22,5.56.35,11.19.35,16.89a9,9,0,0,0,18,0C134.7,71.59,117.28.32,84,.32Z"
            ></path>
            <path
                className="fill-[#f9b215]"
                d="M67.62,150.5a9,9,0,0,1-9-9c0-40-13.15-64.45-20.31-64.45S18,101.52,18,141.5a9,9,0,0,1-18,0c0-20.73,3.28-40.36,9.23-55.27,4-10.15,13.21-27.18,29.08-27.18s25,17,29.09,27.18c6,14.91,9.22,34.54,9.22,55.27a9,9,0,0,1-9,9Z"
            ></path>
            <path
                className="fill-[#f9b215]"
                d="M38.32,82.59a2.59,2.59,0,0,0-2.58,2.58h0a2.57,2.57,0,0,0,2.57,2.57,2.52,2.52,0,0,0,1.62-.57,2.57,2.57,0,0,0-1.61-4.57Z"
            ></path>
            <path
                className="fill-[#f9b215]"
                d="M34.44,91.15a2.57,2.57,0,1,0,1,3.5,2.44,2.44,0,0,0,.34-1.27A2.58,2.58,0,0,0,34.44,91.15Z"
            ></path>
            <path className="fill-[#f9b215]" d="M43.52,90.8a2.57,2.57,0,1,0,2.57,2.58,2.57,2.57,0,0,0-2.57-2.58Z"></path>
            <path
                className="fill-[#f9b215]"
                d="M30.94,99.82a2.47,2.47,0,0,0-1.32-.38,2.57,2.57,0,1,0-.11,5.14h.11a2.57,2.57,0,0,0,1.32-4.77Z"
            ></path>
            <path
                className="fill-[#f9b215]"
                d="M46,99.44a2.42,2.42,0,0,0-.47,0,2.57,2.57,0,0,0,.47,5.1,2.67,2.67,0,0,0,1-.21,2.57,2.57,0,0,0-1-4.94Z"
            ></path>
            <path className="fill-[#f9b215]" d="M40.4,102a2.57,2.57,0,1,0-2.57,2.58A2.57,2.57,0,0,0,40.4,102Z"></path>
            <path
                className="fill-[#f9b215]"
                d="M28.23,109.9a2.55,2.55,0,0,0-4.64,1.44,2.5,2.5,0,0,0,.46,1.45,2.54,2.54,0,0,0,4.18-2.89Z"
            ></path>
            <path className="fill-[#f9b215]" d="M42.34,108.77a2.54,2.54,0,1,0,2.54,2.54h0A2.54,2.54,0,0,0,42.34,108.77Z"></path>
            <path className="fill-[#f9b215]" d="M34.23,108.77a2.54,2.54,0,1,0,2.54,2.54h0A2.54,2.54,0,0,0,34.23,108.77Z"></path>
            <path className="fill-[#f9b215]" d="M52,109.84a2.54,2.54,0,1,0,.77,1.81A2.57,2.57,0,0,0,52,109.84Z"></path>
            <path
                className="fill-[#f9b215]"
                d="M26.7,118a2.48,2.48,0,0,0-1-.2,2.58,2.58,0,1,0-.32,5.15,1.71,1.71,0,0,0,.32,0H26a2.56,2.56,0,0,0,.66-4.92Z"
            ></path>
            <path className="fill-[#f9b215]" d="M42.15,117.84a2.58,2.58,0,1,0,2.57,2.59h0A2.58,2.58,0,0,0,42.15,117.84Z"></path>
            <path className="fill-[#f9b215]" d="M33.94,117.84a2.58,2.58,0,1,0,2.57,2.59h0A2.59,2.59,0,0,0,33.94,117.84Z"></path>
            <path
                className="fill-[#f9b215]"
                d="M49.93,117.84h0a2.57,2.57,0,1,0,0,5.14h0a2.37,2.37,0,0,0,.65-.09,2.57,2.57,0,0,0-.65-5.06Z"
            ></path>
            <path
                className="fill-[#f9b215]"
                d="M25.6,127.35a2.57,2.57,0,1,0-1.67,4.86,2.45,2.45,0,0,0,.8.14,2.33,2.33,0,0,0,.53-.06,2.57,2.57,0,0,0,.34-4.93Z"
            ></path>
            <path className="fill-[#f9b215]" d="M42.15,127.19a2.58,2.58,0,1,0,2.57,2.59h0a2.57,2.57,0,0,0-2.56-2.58Z"></path>
            <circle className="fill-[#f9b215]" cx="32.94" cy="129.77" r="2.57"></circle>
            <path
                className="fill-[#f9b215]"
                d="M51,127.2h-.09a2.58,2.58,0,0,0,0,5.15,3.23,3.23,0,0,0,.44,0,2.57,2.57,0,0,0-.35-5.1Z"
            ></path>
            <path
                className="fill-[#f9b215]"
                d="M25.07,137a2.57,2.57,0,0,0-4,2.14h0a2.61,2.61,0,0,0,.42,1.41,2.59,2.59,0,0,0,2.16,1.17A2.52,2.52,0,0,0,25,141.3a2.56,2.56,0,0,0,.87-3.51A2.44,2.44,0,0,0,25.07,137Z"
            ></path>
            <path className="fill-[#f9b215]" d="M42.09,141.69a2.58,2.58,0,1,0-2.58-2.58h0A2.59,2.59,0,0,0,42.09,141.69Z"></path>
            <circle className="fill-[#f9b215]" cx="32.88" cy="139.11" r="2.57"></circle>
            <path
                className="fill-[#f9b215]"
                d="M51.87,136.54h-.32a2.56,2.56,0,0,0,.08,5.09h.24a2.58,2.58,0,1,0,.32-5.15h-.32Z"
            ></path>
            <path className="fill-[#f9b215]" d="M24.48,145.48a2.4,2.4,0,0,0-.75-.12,2.6,2.6,0,1,0,.75.12Z"></path>
            <path className="fill-[#f9b215]" d="M42.15,145.36a2.57,2.57,0,1,0,2.57,2.57,2.57,2.57,0,0,0-2.57-2.57Z"></path>
            <circle className="fill-[#f9b215]" cx="32.94" cy="147.93" r="2.57"></circle>
            <path className="fill-[#f9b215]" d="M52.12,145.37h-.19a2.57,2.57,0,0,0,0,5.14,2.57,2.57,0,0,0,.19-5.14Z"></path>
        </svg>
    );
};

export default MatBiMIcon;
